<template>
  <div class="content-ht">
     <nav
      class="main-header">
     <div class="logo_wrapper">
        <div class="div-center">
          <img class="img-responsive" @click="goToLogin" src="/static/images/logos/ulimage.svg" alt="rams-logo" />
        </div>
      </div>
      <div class="body-wrapper">
        <div class="col-lg-7 col-md-7 col-sm-6 pl-0" style="padding-left:0px">
          <div class="l1"></div>
          <div class="col-md-11 col-sm-11 pl-16">
             <p class="logo-text mb-0">Conformity Declaration Management</p>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-6 pr-24">
            <div class=" login-header-actions d-flex  justify-content-end md-hide">
           <router-link to="/register" class="log-in font-bold font-18 pr-40" v-if="showSignUp">{{$t('createAccount')}}</router-link>
           <router-link to="/login" class="log-in font-bold font-18 pr-32" v-if="showLogin">{{$t('login')}}</router-link>
           <div class="lang-dropdown">
              <multiselect
              :showLabels="false"
              class="multiselect-single-dropdown"
              v-model="languageSelected"
              :placeholder="$i18n.locale === 'Portuguese' ? 'Português' : 'English'"
              :options="languages"
              :custom-label="(opt) => languages.find((x) => x == opt) || ''"
              :searchable="false"
              @select="changeLanguage($event)"
              >
            </multiselect>
            </div>
         </div>
         <div class="col-xs-4 show-md mobile-menu-btn pr-0">
          <div class="d-flex menu-btn align-items-end flex-direction-column row-gap-5" type="button"
            aria-expanded="false"
            data-toggle="collapse"
            data-target="#NavBar_DropDown_Login">
             <img src="/static/images/icons/burger_icon.svg" class="downCarret" />
          </div>
      </div>
        </div>
      </div>
        <ul id="NavBar_DropDown_Login" aria-expanded="false" class="collapse p-20" ref="navbarDropdown">
        <li class="pl-16">
          <div class="userProfileDropDown">
            <div class="language_dropdown">
              <div class="languagePlaceholder">{{$t('language')}}</div>
              <div class="carretSection">
                <span>
                      <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                        <img src="/static/images/icons/loginHeaderLanguageDropdownIcon.svg" class="downCarret" />
                        <img src="/static/images/icons/loginHeaderLanguageDropdownIcon.svg" class="upCarret" />
                      </button>
                    </span>
              </div>
            </div>
          </div>
        </li>
        <div class="collapse languagesList" id="collapseLanguageDropdown">
              <ul>
                <li class="languageItem">
                  <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                    <div class="settings-title">
                    <div class="li-title" @click="changeLanguage('English')">{{$t('english')}}</div>
                    </div>
                  </button>
                </li>
                <li class="languageItem portugueseItem">
                  <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                    <div class="settings-title">
                    <div class="li-title" @click="changeLanguage('Portuguese')">{{ $t('portuguese')}}</div>
                    </div>
                  </button>
                </li>
              </ul>
            </div>
        <li class="pl-16">
          <router-link
            data-toggle="collapse"
            data-target="#NavBar_DropDown_Login"
            to="/register"
            @click="closeDropdown"
          >{{$t('createAccount')}}</router-link>
        </li>
        <li class="pl-16">
          <router-link data-toggle="collapse" data-target="#NavBar_DropDown_Login" to="/login" @click="closeDropdown" >{{$t('login')}}</router-link>
        </li>
        <li @click="openSaasModal('sass')" class="pl-16">
          <a>{{$t('termsAndConditions')}}</a>
        </li>
        <!-- <li @click="openSaasModal('sass')" class="pl-16">
          <a>Contact Us</a>
        </li> -->
        <li @click="openSaasModal('termsOfUse')" class="pl-16">
          <a>{{$t('paymentTerms')}}</a>
        </li>
        <li @click="openSaasModal('privacyPolicy')" class="pl-16">
          <a>{{$t('privacyPolicy')}}</a>
        </li>
      </ul>

          <!-- <ul id="NavBar_DropDown_Register" aria-expanded="false" class="collapse p-20">
      <img class="medium_device_logo" alt="inmetro-logo" src="/static/images/logos/inmetro_medium_device_logo.svg" />
      <li class="padding-0">
        <div class="break-line"></div>
      </li>
      <li>
        <div class="userProfileDropDown">
          <div class="language_dropdown">
            <div class="languagePlaceholder">adasd{{$t('language')}}</div>
            <div class="carretSection">
              <span>
                    <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                      <img src="/static/images/icons/chevron_up_purple.svg" class="downCarret" />
                      <img src="/static/images/icons/chevron_up_purple.svg" class="upCarret" />
                    </button>
                  </span>
            </div>
          </div>
               <div class="collapse languagesList" id="collapseLanguageDropdown">
                 <ul>
                   <li class="languageItem">
                     <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                       <div class="settings-title">
                         <div class="li-title" @click="changeLanguage('English')">{{$t('english')}}</div>
                       </div>
                     </button>
                   </li>
                   <li class="languageItem portugueseItem">
                     <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                       <div class="settings-title">
                         <div class="li-title" @click="changeLanguage('Portuguese')">{{$t('portuguese')}}</div>
                       </div>
                     </button>
                   </li>
                 </ul>
               </div>
           </div>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li>
        <router-link
          data-toggle="collapse"
          data-target="#NavBar_DropDown_Register"
          to="/register"
        >{{$t('createAccount')}}</router-link>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li>
        <router-link data-toggle="collapse" data-target="#NavBar_DropDown_Register" to="/login">{{$t('login')}}</router-link>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('sass')">
        <a>{{$t('inmetroSaaSAgreement')}}</a>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('termsOfUse')">
        <a>{{$t('inmetroTermsOfUse')}}</a>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('privacyPolicy')">
        <a>{{$t('privacyPolicy')}}</a>
      </li>
    </ul> -->
    </nav>
  </div>
 </template>
<script>
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      agreementType: '',
      languages: ['English', 'Portuguese'],
      // banners: [],
      // showDialog: false,
      selectedLanguageLabel: 'English',
      languageSelected: '',
      selectLanguage: '',
    };
  },
  props: {
    showLogin: {
      required: false,
    },
    showSignUp: {
      required: false,
    },
  },
  watch: {
    languages(newValue) {
      if (newValue.includes('English')) this.languageSelected = 'English';
      else this.languageSelected = 'Português';
    },
  },
  components: {
    // NotificationBanner,
  },
  created() {
    this.$i18n.locale = localStorage.getItem('language') || this.$i18n.locale;
    if (this.$i18n.locale === 'Portuguese') {
      this.languages = ['Inglês', 'Português'];
      this.languageSelected = 'Português';
    } else {
      this.languageSelected = 'English';
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('login');
    },
    closeDropdown() {
      this.$refs.navbarDropdown.classList.remove('in');
    },
    openSaasModal(data) {
      this.closeDropdown();
      this.$emit('openModal', data);
    },
    changeLanguage(language) {
      if (['Portuguese', 'Português'].includes(language)) {
        this.selectedLanguageLabel = 'Portuguese';
        this.$i18n.locale = 'Portuguese';
        EventBus.$emit('languageChanged', this.$i18n.locale);
        this.languages = ['Inglês', 'Português'];
      } else {
        this.selectedLanguageLabel = 'English';
        this.$i18n.locale = 'English';
        EventBus.$emit('languageChanged', this.$i18n.locale);
        this.languages = ['English', 'Portuguese'];
      }
      localStorage.setItem('language', this.$i18n.locale);
    },
  },
};
</script>
 <style scoped>
 .pr-40 {
    padding-right:40px
 }
  .pr-32 {
    padding-right:32px
 }
 .logo-text {
  float: left;
  padding: 11px 0 12px 0px;
  margin-bottom: 0px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #CA0123;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .l1 {
  position: absolute;
   height: 15px;
  margin: 18px 0px 18px 0px;
  border-left: 2px solid #D3D3D3;;
  float: left;
}
 .div-center {
  padding: 9px 16px 9px 16px;
  cursor: pointer;
}
 .content-ht {
  max-height: 50px;
}
.main-header {
  height: 50px;
  background: #fff;
  /* border-bottom: 1px solid #D3D3D3; */
}

.body-wrapper {
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 25%); */
  float: left;
  width: 100%;
  padding-left: 110px;
  z-index: 100;
  background: #ffffff;
  position: fixed;
  top: 0px;
  height: 50px;
  border-bottom: none;
  border-bottom: 1px solid #D3D3D3;
}
.logo_wrapper {
  /* padding: 28px 0px 31px 44px;  */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  background: #ffffff;
  position: fixed;
  float: left;
  height: 50px;
  z-index: 101;
  border-bottom: none;
  border-bottom: 1px solid #D3D3D3;
}
.multiselect {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    display: block;
    position: relative;
    width: 100%;
    min-height: 33px !important;
    text-align: left;
    /* color: #35495e; */
}
.inmetro-logo-section {
  padding-top: 11px;
  padding-left: 9px;
}
.pt-6 {
  padding-top: 6px !important;
}
.lang-dropdown{
    width: 146px;
    /* padding-top:3px; */
}
.lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper::before{
    content: '';
    position: absolute;
    top: 0;
    /* left: 10px; */
    border:  1px solid #0A99FF;
    /* opacity:0.5; */
    width: 100%;
}
.lang-dropdown .multiselect-single-dropdown.multiselect--active::before {
  content: none;
}
.lang-dropdown .multiselect-single-dropdown >>> .multiselect__content-wrapper .multiselect__option--highlight{
  height: auto;
    background: none;
    border: 1px solid #0A99FF;
}
.lang-dropdown .multiselect-single-dropdown >>> .multiselect__option {
  white-space: pre-wrap;
  text-align: left;
  /* padding: 12px 28px 12px 18px; */
  min-height: 34px !important;
  line-height: 19px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #0B3C61;

}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__content-wrapper ul li:first-child{
  /* margin-top: 6px !important; */
}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__select{
 position: absolute;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 6px 6px 10px 0px;
    text-align: center;
    transition: transform .2s ease, -webkit-transform .2s ease;
    /* max-height: 33px; */
}
.lang-dropdown .multiselect--active
>>> .multiselect__select{
  padding-top: 5px !important;
  padding-bottom: 7px !important;
  padding-left: 13px;
  padding-right: 7px;
}
.lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__placeholder{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    color: #3E3E3E;
    overflow: visible;
    padding-left:0px;
  }
  .lang-dropdown  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    /* background: #e6e6e6 !important; */
    /* font-weight: 600 !important; */
    border: 1px solid #0A99FF;
  }
  .lang-dropdown .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
    overflow: visible;
    padding-left:0px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__placeholder{
    display: block !important;
  }
  .multiselect--above.multiselect--active
  >>>  .multiselect__single,
  .multiselect--above.multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__tags{
    /* border-top-left-radius: 3px;
    border-top-right-radius: 3px; */
    border-radius: 3px !important;
    background: #FFFFFF;
    height: 33px;
    padding: 2px 40px 5px 16px;
    border: 1px solid #4D4D4D;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__select:before{
    /* -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border: 1px solid #000000;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 6px;
    top: 0px;
    content: "";
    margin-top: 2px; */
    position: relative;
    right: 0;
    /* top: 65%; */
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    /* -webkit-transform: rotate(45deg); */
    /* border: 1px solid #0b3c61;
    border-width: 0 2px 2px 0;
    display: inline-block; */
    padding: 0px !important;
  }
  .lang-dropdown .multiselect--active:not(.multiselect--above)
  >>> .multiselect__tags{
    /* border-radius:0px !important; */
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-bottom: none !important;
  }
  /* .lang-dropdown .multiselect-single-dropdown >>> .multiselect__select:before {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  border: 1px solid #0b3c61;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  top: 0px;
  content: "";
} */
  .lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper{
    border-top: none !important;
    margin-top: 0px !important;
    border:1px solid #CCCCCC;
    box-shadow: none !important;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    margin-top: 0px !important;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

  }
   .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__tags{
    border-radius: 0px !important;
    border-bottom: 0px;
    border:1px solid #0A99FF !important;
  }
   /* .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight{
    border: 1px solid #0A99FF;
  } */
  /* .lang-dropdown .multiselect--active
  >>> .multiselect__option:hover{
    background: #e6e6e6 !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight{
    background: #e6e6e6 !important;
    font-weight: 600 !important;
  } */
  /* .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight span{
    font-weight: 600 !important;
  } */
  .lang-dropdown .multiselect--above.multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element{
    float: unset !important;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 13px;
    padding-top:5px;
    padding-bottom: 5px;
    padding-right: 0px;
  }
 /* ========================================== */
 .auth-container {
   position: relative;
   padding-bottom: 58px;
   min-height: 100vh;
   margin-left: 0px;
   margin-right: 0px;
   background-image: url('/static/images/logos/login_page_bg_image.jpg');
   background-repeat: no-repeat;
   background-size: cover;
   background-position: center;
   overflow-x: hidden;
 }
 .login-header-actions{
   /* padding-right: 40px; */
   align-items: center;
   padding-bottom: 9px;
   padding-top:9px
 }
 .login-header-actions a {
   font-family: 'Open Sans';
   font-style: normal;
   font-weight: 600;
   font-size: 18px;
   line-height: 25px;
   color: #00518A;;
 }
 .col-gap-40 {
     -webkit-column-gap: 40px;
     -moz-column-gap: 40px;
     column-gap: 40px;
 }
 .userProfileDropDown .dropdown-menu::after {
   content: '';
   position: absolute;
   right: 29px;
   top: -11px;
   width: 20px;
   height: 20px;
   background: inherit;
   border-style: solid;
   border-width: 1px 0 0 1px;
   transform: rotate(45deg);
   border-color: rgba(0, 0, 0, 0.3) transparent transparent rgba(0, 0, 0, 0.3);
   z-index:9998;
 }
 .img-size {
   width: 30px;
   height: 18px;
   cursor: default;
 }
 .li-title {
   color: #3E3E3E;
   font-size: 14px;
 }
 .row-gap-5 {
   row-gap: 5px;
   padding-right: 10px;
 }
 .align-items-center {
   align-items: center;
 }
 .align-items-end {
   align-items: flex-end;
 }
 .flex-direction-column {
   flex-direction: column;
 }
 .justify-content-end {
   justify-content: flex-end;
 }
 div.x,
 div.y,
 div.z {
   height: 3px;
   width: 29px;
   background: #ffffff;
   border-radius: 2px;
   -webkit-transition: all 200ms ease-out;
   -o-transition: all 200ms ease-out;
   transition: all 200ms ease-out;
   cursor:pointer;
 }
 .menu-btn[aria-expanded="true"] > div.x {
   transform: rotate(45deg);
   transform-origin: top left;
 }
 .menu-btn[aria-expanded="true"] > div.y {
   background: #FFFFFF;
   display: none;
 }
 .menu-btn[aria-expanded="true"] > div.z {
   transform: rotate(-45deg);
   transform-origin: bottom left;
   margin: 10px 1px 3px 3px;
 }
 .mobile-menu {
   position: absolute;
   width: 100%;
   z-index: 1;
   background-image: url('/static/images/logos/login_page_bg_image.jpg');
 }
 .pl-16{
  padding-left: 16px !important;
 }
 #NavBar_DropDown_Login {
    height: auto;
    height: -moz-max-content;
    height: -webkit-fit-content;
    min-height: -webkit-fit-content;
    min-height: -moz-fit-content;
    min-height: fit-content;
    padding: 12px 0px 12px 0px;
    background: #FFFFFF;
    border-radius: 5px;
    -webkit-box-shadow: 2px 4px 15px rgb(0 0 0 / 25%);
    box-shadow: 2px 4px 15px rgb(0 0 0 / 25%);
    position: fixed;
    right: 3px;
    width: 303px;
    top: -2px;
    bottom: 0;
    margin-top: 50px;
    color: black;
    z-index: 100;
  }
  #NavBar_DropDown_Login::before{
    position: absolute;
    top: -14px;
    height: 0;
    width: 0;
    left: 89%;
    border: 8px solid transparent;
    border-bottom-color: #fff;
    content: "";
}
  #NavBar_DropDown_Login li {
    list-style: none;
    padding: 6px 0px 6px 0px;
  }
  /* #NavBar_DropDown_Login li:nth-child(even) {
    padding: 9px 0px;
  } */
  #NavBar_DropDown_Login li:first-child,
  #NavBar_DropDown_Login li:first-child:hover {
    /* padding-top: 12px; */
    /* background-color: unset !important; */
  }
  #NavBar_DropDown_Login li:hover{
    background-color: #e6e6e6;
  }
  #NavBar_DropDown_Login li a {
    cursor: pointer;
    color: #4d4d4d;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
  }
  .medium_device_logo {
    padding-top: 46px;
    padding-left: 38px;
    padding-bottom: 24px;
  }
  .padding-0 {
    padding: 0 !important;
  }
  .break-line {
    border-bottom: 1px solid #B4B4B4;
    margin: 0 16px;
  }
  .horizontal-line {
    border-bottom: 1px solid #D3D6D9;
    margin: 0 28px;
  }
  /* Language Dropdown in Mobile&Tablet*/
  /* .userProfileDropDown{
    padding-top: 18px;
  } */
  .userProfileDropDown .language_dropdown .carretSection span button[aria-expanded="true"] img.upCarret{
      display: inline-block;
    }
    .userProfileDropDown .language_dropdown .carretSection span button[aria-expanded="true"] img.downCarret{
      display: none;
    }
    .userProfileDropDown .language_dropdown .carretSection span button img.downCarret {
      display: inline-block;
      transform: rotate(180deg);
    }
    .userProfileDropDown .language_dropdown .carretSection span button img.upCarret{
      display: none;
    }
    .language_dropdown{
    display: flex;
      align-items: center;
      justify-content: space-between;
  }
  .language_dropdown .languagePlaceholder{
    color: #4d4d4d;
    font-weight: 400;
    font-size: 16px;
    font-family: 'Open Sans';
    font-style: normal;
    line-height: 22px;
  }
  .language_dropdown button{
    background-color: transparent !important;
      padding: 0px;
      border: none;
  }
  .languagesList button{
    background-color: transparent !important;
      padding: 0px;
      border: none;
  }
  .carretSection{
      padding-right: 16px;
    }
    .downCarret,
    .upCarret{
      width: 19px;
      height: 19px;
    }
    .languagesList ul li button .li-title{
      /* padding-left: 28px; */
      color: #4d4d4d;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
    }
    .languagesList ul li button{
      padding-left: 0px !important;
    }
    .languagesList ul li .settings-title{
      padding-left: 0px !important;
      /* padding-top: 12px; */
    }
    .languagesList ul{
      padding-left: 0px;
    }
    .portugueseItem{
      /* padding-top: 0px !important; */
      /* padding-bottom: 0px !important; */
    }
    .languageItem{
      margin-right: auto;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 19px;
      color: #01518a;
      padding-left: 32px !important;
    }
    /* Burger menu */
  div.x,
  div.y,
  div.z {
    height: 3px;
    width: 29px;
    background: #FFFFFF;
    border-radius: 2px;
    -webkit-transition: all 200ms ease-out;
    -o-transition: all 200ms ease-out;
    transition: all 200ms ease-out;
  }
  .menu-btn[aria-expanded="true"] > div.x {
    transform: rotate(40deg);
    transform-origin: top left;
    background: #333333;
  }
  .menu-btn[aria-expanded="true"] > div.y {
    background: #333333;
    display: none;
  }
  .menu-btn[aria-expanded="true"] > div.z {
    transform: rotate(-45deg);
    background: #333333;
    transform-origin: bottom left;
    margin: 10px 1px 3px 3px;
  }
  .mobile-menu-btn {
    position: absolute;
    right: 10px;
    top: 17px;
    z-index: 2;
  }
  .mobile-menu-btn .menu-btn{
  cursor: pointer;
}
 @media screen and (max-width: 767px) {
   div.x,
   div.y,
   div.z {
     height: 3px;
     width: 29px;
     background: #FFFFFF;
     border-radius: 2px;
     -webkit-transition: all 200ms ease-out;
     -o-transition: all 200ms ease-out;
     transition: all 200ms ease-out;
   }
 }
 @media (min-width: 1025px) and (max-width: 1300px) {
    .md-hide {
      display: none !important;
    }
  }
  @media screen and (max-width: 1300px) {
  .mobile-menu-btn .menu-btn{
    float: right !important;
  }
  }
 @media only screen and (max-width: 1024px) {
   .md-hide {
     display: none;
   }
   /* .checkbox-register{
    margin-top: 0px !important;
   } */
 }
 @media only screen and (min-width: 1301px) {
  #NavBar_DropDown_Login {
    display: none;
  }
    .show-md {
      display: none !important;
    }
  }
  .profileNameDropdownList{
    height: auto;
    /* max-height: calc(100vh - 80px);
    overflow-y: auto; */
    height: -moz-max-content;
    height: -webkit-fit-content;
    min-height:fit-content;
    padding-bottom: 18px;
    padding-top: 17px;
    background: #FFFFFF;
    border-radius: 5px;
    box-shadow: 2px 4px 15px rgb(0 0 0 / 25%);
    position: fixed;
    right: 12px;
    width: 208px;
    top: -6px;
    bottom: 0;
    margin-top: 50px;
    color: black;
    z-index: 100;
}
.profileNameDropdownList::before{
    position: absolute;
    top: -14px;
    height: 0;
    width: 0;
    left: 89%;
    border: 8px solid transparent;
    border-bottom-color: #fff;
    content: "";
}

</style>
